import { Button } from "@material-ui/core";
import React from "react";
import "./ReportsNav.less";

class ReportingSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultReport: props.defaultReport,
      navLinks: [],
      reportsNavList: props.reportsNavList
    };
  }
  componentDidMount() {
    const {reportsNavList} =this.state;
    const navLinks = reportsNavList.filter(x => {
      return x;
    });
    this.setState({
      navLinks: navLinks,
      defaultReport: (navLinks[0] || {}).ReportSectionDisplayName
    });
    this.props.onNavClick((navLinks[0] || {}).ReportSectionId);
  }

  /**
   * set value of active report according to ReportSectionId
   * @param {*} reportTitle - selected report
   */
  activeReport = reportTitle => {
    this.setState({ defaultReport: reportTitle.ReportSectionDisplayName });
    this.props.onNavClick(reportTitle.ReportSectionId);
  };

  render() {
    const WidthStyle = "calc(100%/" + this.state.navLinks.length + ")";
    return (
      <>
        <div className={"row"}>
          {(this.state.navLinks || []).map((item, index) => (
            <div
              key={"ReportNavButtons" + index}
              className={
                this.state.defaultReport == item.ReportSectionDisplayName
                  ? "col-xs-4"
                  : " col-xs-4"
              }
              style={{ width: WidthStyle }}
              onClick={() => this.activeReport(item)}
            >
              <Button
                className={
                  item.IsEnable == true
                    ? "runReport-button"
                    : "disable-runReport-button"
                }
                variant={"contained"}
                disabled={!item.IsEnable}
                onClick={() => {
                  this.props.getReportBySection(item);
                }}
              >
                {item.ReportSectionDisplayName}{" "}
              </Button>
            </div>
          ))}
        </div>
      </>
    );
  }
}

export default ReportingSection;
